"use client";

import { FileText, ArrowRight, BookOpen } from "lucide-react";
import Link from "next/link";

const ArticleCard = ({ article }) => {
    const formatDate = (dateString) => {
        if (!dateString) return "TBD";

        // Handle different date formats
        let date;
        if (typeof dateString === 'string') {
            date = new Date(dateString);
        } else if (dateString.$date) {
            // MongoDB date object
            date = new Date(dateString.$date);
        } else {
            date = new Date(dateString);
        }

        if (isNaN(date.getTime())) return "TBD";

        return date.toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    };

    return (
        <Link href={`/blog/${article.slug}`}>
            <div
                className="group cursor-pointer rounded-lg overflow-hidden transition-all duration-300 hover:-translate-y-1"
                style={{
                    backgroundColor: 'var(--color-card)',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderColor: 'var(--color-border)'
                }}
            >
            {/* Feature Image */}
            {article.featuredImage && (
                <div className="w-full h-48 overflow-hidden relative" style={{ backgroundColor: 'var(--color-muted)' }}>
                    <img
                        src={article.featuredImage}
                        alt={article.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                        onError={(e) => {
                            e.target.style.display = "none";
                        }}
                    />
                    {/* Article Badge */}
                    <div
                        className="absolute top-2 sm:top-3 left-2 sm:left-3 px-2 sm:px-3 py-1 sm:py-1.5 rounded-full text-xs font-semibold"
                        style={{
                            backgroundColor: 'var(--color-primary)',
                            color: 'var(--color-primary-foreground)'
                        }}
                    >
                        ARTICLE
                    </div>
                </div>
            )}

            <div className="p-2 space-y-2">
                <h3 className="text-sm md:text-base font-bold transition-colors line-clamp-2 group-hover:text-primary"
                    style={{ color: 'var(--color-heading)' }}>
                    {article.title}
                </h3>

                {/* Description/Excerpt */}
                {article.excerpt && (
                    <p className="text-xs line-clamp-2" style={{ color: 'var(--color-paragraph)' }}>
                        {article.excerpt}
                    </p>
                )}

                {/* Date */}
                <div className="flex items-center text-xs" style={{ color: 'var(--color-muted-foreground)' }}>
                    <BookOpen className="w-3 h-3 mr-1" style={{ color: 'var(--color-primary)' }} />
                    <span>{formatDate(article.publishDate || article.publishedAt || article.createdAt)}</span>
                </div>

                {/* View More Button */}
                <div className="flex items-center pt-2"
                    style={{ borderTopWidth: '1px', borderTopColor: 'var(--color-border)' }}>
                    <span className="text-xs font-semibold group-hover:text-primary transition-colors"
                        style={{ color: 'var(--color-link)' }}>
                        Read Article
                    </span>
                    <ArrowRight className="w-3 h-3 ml-2 group-hover:translate-x-1 transition-transform duration-200"
                        style={{ color: 'var(--color-link)' }} />
                </div>
            </div>
        </div>
        </Link>
    );
};

export default ArticleCard;
